
import Vue from "vue";
import { FETCH_OVERALL_ASSESSMENTS } from "@/store/modules/recruiter/constants";
import { AppAssessmentNames } from "@/store/modules/common/interfaces";
import {
  AppOverAllAssessmentListing,
  AssessmentVersions,
  DateFilterPayload
} from "@/store/modules/recruiter/interfaces";
import { TranslateResult } from "vue-i18n";
import SelectOptions from "@/components/recruiter/SelectOptions.vue";
import { SelectedFilters } from "@/interfaces/shared/selected_filters";
import AutoCompleteUserAndEidSearch from "@/components/shared/AutoCompleteUserAndEidSearch.vue";
import AssessmentsFilter from "@/components/recruiter/AssessmentsFilter.vue";
import { SearchUserObject } from "@/interfaces/shared/auto_complete_user_search";
import AssessmentsSelectedDatePicker from "@/components/recruiter/app_assessment/AssessmentsSelectedDatePicker.vue";

interface FilterPayload {
  average_score: number[];
  english_score: number[];
  annotation_score: number[];
  assessment_versions: AssessmentVersions[];
}

export default Vue.extend({
  name: "AppAssessmentListingFilterHeader",
  components: {
    SelectOptions,
    AssessmentsFilter,
    AssessmentsSelectedDatePicker,
    AutoCompleteUserAndEidSearch
  },
  props: {
    version: {
      type: String
    },
    is_overall_result: {
      type: Boolean,
      default: false
    },
    singleDateOnly: {
      type: Boolean,
      default: false
    },
    showExport: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dates: [] as string[],
      exporting: false,
      english_placeholder: this.$t("auth.name") as TranslateResult,
      annotation_placeholder: this.$t("auth.name") as TranslateResult,
      pass_fail_filters: [
        { label: this.$t("assessments.both"), value: "both" },
        { label: this.$t("assessments.pass"), value: "pass" },
        { label: this.$t("assessments.fail"), value: "fail" }
      ] as SelectedFilters[],
      version_filters: [
        { label: "Version 4", value: AssessmentVersions.VERSION_4 }
      ] as SelectedFilters[]
    };
  },
  computed: {
    AppAssessmentNames() {
      return AppAssessmentNames;
    },
    GetAssessments(): AppOverAllAssessmentListing {
      return this.$store.getters[`recruiter/${FETCH_OVERALL_ASSESSMENTS}`];
    },
    PassFailAssessmentFilter(): string {
      return this.GetAssessments.score_filter;
    },
    AssessmentVersions(): AssessmentVersions[] {
      return this.GetAssessments.assessment_versions;
    },
    StatusAssessmentFilter(): string {
      const def = "all";
      return def;
    },
    SelectedDates(): DateFilterPayload {
      return this.GetAssessments.selected_dates;
    },
    AverageFilter(): number[] {
      return this.GetAssessments.average_score_filter;
    },
    EnglishFilter(): number[] {
      return this.GetAssessments.english_assessment_filter;
    },
    AnnotationFilter(): number[] {
      return this.GetAssessments.annotation_assessment_filter;
    },
    EidNameFilter(): string {
      return this.GetAssessments.eid_name_filter;
    }
  },
  methods: {
    async on_export() {
      this.exporting = true;
      try {
        await this.$emit("export_report");
      } finally {
        this.exporting = false;
      }
    },
    searched_user(value: SearchUserObject[]) {
      this.GetAssessments.selected_candidates = value;
      this.GetAssessments.page = 1;
      this.$emit("filter_change");
    },
    on_selected_dates(dates: DateFilterPayload) {
      this.GetAssessments.selected_dates = dates;
      this.GetAssessments.page = 1;
      this.$emit("filter_change");
    },
    update_score_filter(filter: string) {
      this.GetAssessments.score_filter = filter;
      this.GetAssessments.page = 1;
      this.$emit("filter_change");
    },
    update_status_filter(filter: string) {
      this.$emit("update_status_filter", filter);
    },
    filter_change(filter: FilterPayload) {
      this.GetAssessments.average_score_filter = filter.average_score;
      this.GetAssessments.english_assessment_filter = filter.english_score;
      this.GetAssessments.annotation_assessment_filter =
        filter.annotation_score;
      this.GetAssessments.assessment_versions = filter.assessment_versions;
      this.GetAssessments.page = 1;
      this.$emit("filter_change");
    },
    update_eid_name_filter(filter: string) {
      this.GetAssessments.eid_name_filter = filter;
    }
  }
});
